export default {
	id: 'SIMPLE_PAYWALL_4W_29_99_4W_44_00',
	providers: {
		paltaMap: {
			USD: 'simple_premium_4w_29_99_4w_44_usd',
			EUR: 'simple_premium_4w_29_99_4w_44_eur',
			GBP: 'simple_premium_4w_29_99_4w_44_gbp',
			CAD: 'simple_premium_4w_49_99_4w_69_cad',
			AUD: 'simple_premium_4w_49_99_4w_69_aud',
			DKK: 'simple_premium_4w_259_4w_379_dkk',
			SEK: 'simple_premium_4w_399_4w_584_sek',
			NOK: 'simple_premium_4w_399_4w_584_nok',
			BRL: 'simple_premium_4w_199_90_4w_294_90_brl',
			MXN: 'simple_premium_4w_499_4w_729_mxn',
			TRY: 'simple_premium_4w_999_4w_1499_try',
			ARS: 'simple_premium_4w_58000_4w_58000_ars',
			COP: 'simple_premium_4w_178000_4w_178000_cop',
			CLP: 'simple_premium_4w_42000_4w_42000_clp',
		},
		primer: 'prd_8CJz8ItWfgDM',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 4,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 28,
		priceMap: {
			USD: 44,
			EUR: 44,
			GBP: 44,
			CAD: 69,
			AUD: 69,
			DKK: 379,
			SEK: 584,
			NOK: 584,
			BRL: 294.9,
			MXN: 729,
			TRY: 1499,
			ARS: 58000,
			COP: 178000,
			CLP: 42000,
		},
		originalPriceMap: {},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 30,
			EUR: 30,
			GBP: 30,
			CAD: 50,
			AUD: 50,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 199.9,
			MXN: 499,
			TRY: 999,
			ARS: 58000,
			COP: 178000,
			CLP: 42000,
		},
	},
}
